module.exports = __webpack_public_path__ + "img/binance1.b72d2fe7.png";